import { render, staticRenderFns } from "./BaseResourceProperty.vue?vue&type=template&id=16f3c46c"
import script from "./BaseResourceProperty.vue?vue&type=script&lang=ts"
export * from "./BaseResourceProperty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports